import type { RESOURCE_KEYS } from "./keys";

// eslint-disable-next-line camelcase
export const en_US: typeof RESOURCE_KEYS = {
	step1: {
		title: "Enter your information",
		wizardTitle: "Personal Data",
		description: "Please fill out the registration form carefully. Make sure all information is correct.",
		submit: "Request verification code",
		requestCodeError:
			"The verification code could not be requested. Please try again. If the problem persists, please contact support.",
		agb: {
			prefix: "I agree to the",
			terms: "Terms and Conditions",
			middle: "and have been informed of the",
			privacy: "Privacy Policy",
			suffix: "."
		}
	},
	step2: {
		title: "Verify your registration",
		wizardTitle: "Verification",
		description:
			"Please enter your verification code. The code was sent to your email ({email}) and is valid for {minutes} minutes.",
		inputLabel: "Enter code",
		resend: "Resend code",
		codeResent: "Verification code resent. Please check your email.",
		loginLink: "Already registered? Log in now"
	},
	step3: {
		title: "Create password",
		wizardTitle: "Set Password",
		description:
			"Please set your password to secure access to your account. Make sure to choose a strong password.",
		password: "Password *",
		confirmPassword: "Repeat password *",
		submit: "Complete registration",
		registrationError:
			"The registration could not be completed. Please try again. If the problem persists, please contact support.",
		showPassword: "Show password",
		hidePassword: "Hide password",
		passwordStrength: {
			veryWeak: "Very weak",
			weak: "Weak",
			good: "Good",
			strong: "Strong"
		},
		passwordRules: {
			minLength: "At least 12 characters",
			uppercase: "One uppercase letter",
			lowercase: "One lowercase letter",
			digit: "One number",
			specialChar: "One special character"
		},
		startOver: "Start registration again"
	},
	form: {
		firstName: "First name",
		lastName: "Last name",
		email: "Business email address"
	},
	legal: {
		termsTitle: "Terms and Conditions",
		privacyTitle: "Privacy Policy",
		print: "Print",
		close: "Close",
		loading: "Loading document…"
	},
	validation: {
		tooSmall: "This field is required.",
		invalidString: "Invalid input.",
		emailInvalid: "The entered email address is not valid.",
		emailExists: "Email address is already registered!",
		emailDomainNotAllowed: "This email domain is not allowed.",
		emailRequired: "Please enter an email address.",
		verificationCodeInvalid: "The verification code is invalid.",
		codeVerificationLocked: "For security reasons, you can enter a new code in {time}.",
		sessionExpired: "Your session has expired. Please start the registration again.",
		nameTooLong: "At most {max} characters.",
		agbUnchecked: "Please accept the Terms and Conditions.",
		passwordsDontMatch: "The passwords entered do not match. Please check your input.",
		passwordInvalid:
			"The password does not meet the requirements. It must be at least 12 characters long, contain a number, an uppercase letter, a lowercase letter and a special character, and must not contain the email address.",
		passwordEmpty: "Please enter a password.",
		passwordTooShort: "The password must be at least {min} characters long.",
		passwordTooLong: "The password must not exceed {max} characters.",
		passwordUppercaseRequired: "The password must contain at least {count} uppercase character(s).",
		passwordLowercaseRequired: "The password must contain at least {count} lowercase character(s).",
		passwordDigitsRequired: "The password must contain at least {count} digit(s).",
		passwordSpecialCharsRequired: "The password must contain at least {count} special character(s).",
		passwordMatchesUsername: "The password must not be the same as the username.",
		passwordMatchesEmail: "The password must not be the same as the email address.",
		passwordContainsEmail: "The password must not contain the email address.",
		validationFailed: "Please check your input.",
		generalError: "Something went wrong. Please try again."
	},
	wizard: {
		title: "Registration",
		back: "Back",
		stepOf: "Step {current} of {total}",
		footer: {
			alreadyRegistered: "Already registered?",
			loginNow: "Sign in now"
		}
	}
};
